import { FC, useContext, useState } from "react";
import NotificationDispatch, {
  showErrorNotification,
  showSuccessNotification,
} from "../../context/notificationContext";
import { useI18n } from "../../hooks/useTranslations";
import { useCarLeasingApi } from "../../http/carLeasings/api";
import { InsertCarLeasing } from "../../http/carLeasings/types";
import ModalDialog from "../ui/ModalDialog";
import CarLeasingForm, { CarLeasingFormBody } from "./CarLeasingForm";

type CreateCarLeasingDialogProps = {
  onClose: (success?: boolean) => void;
  carId?: string;
};

const CreateCarLeasingDialog: FC<CreateCarLeasingDialogProps> = ({ onClose, carId }) => {
  const i18n = useI18n();
  const dispatch = useContext(NotificationDispatch);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const carLeasingApi = useCarLeasingApi();

  const onSubmit = async (formData: CarLeasingFormBody) => {
    const id = carId ?? formData.car?.id;
    if (id) {
      const body: InsertCarLeasing = {
        carId: id,
        leasingCompanyId: formData.company?.id!,
        contractDate: formData.contractDate,
        contractDetails: formData.details!,
        expirationDate: formData.expirationDate,
      };

      setIsSubmitting(true);
      try {
        await carLeasingApi.insertAdminCarLeasing(body);
        dispatch(showSuccessNotification(i18n.t));
        onClose(true);
      } catch (error) {
        dispatch(showErrorNotification(i18n, error));
      } finally {
        setIsSubmitting(false);
      }
    }
  };

  return (
    <ModalDialog onClose={onClose} title={i18n.t.carLeasings.new}>
      <CarLeasingForm isDisabled={isSubmitting} onSubmit={onSubmit} carId={carId} />
    </ModalDialog>
  );
};

export default CreateCarLeasingDialog;
